import {IUserApi} from '../../api/user-api.service';
import {IInvitedUserData, IInvitationDetails} from '../../api/api.types';
import {StateService} from 'angular-ui-router';
import {IImomoErrorService} from '../../error/error.service';

export interface IInvitationsStateParams {
	invitation_uuid: string;
}

export default class IncitationsController {
	static $inject = ['userApi', '$location', '$state', 'imomoErrorService'];

	private invitationData: IInvitationDetails;
	private invitedUserData: IInvitedUserData = {
		username: null,
		fullName: null
	};

	constructor (
		private userApi: IUserApi,
		private $location: ng.ILocationService,
		private $state:StateService,
		private imomoErrorService: IImomoErrorService
	) {
		if (this.$location.search().invitation_uuid) { 
			this.userApi.getInvitationDetails(this.$location.search().invitation_uuid)
				.then((invitationData) => {
					this.invitationData = invitationData;
					this.invitedUserData.fullName = this.invitationData.fullName;
				})
				.catch((error) => {
					this.imomoErrorService.showErrorDetailsDialog(error.data.details)
						.then(() => {
							this.$state.go('home');
						});
				})
		}
	}

	onRegisterClick() {
		this.userApi.createUserFromInvitation(this.invitedUserData, this.$location.search().invitation_uuid)
			.then(() => {
				this.$state.go('home');
			})
			.catch((error) => {
				this.imomoErrorService.showErrorDetailsDialog(error.data.details);
			})
	}
}


/** WEBPACK FOOTER **
 ** ./app/hydromet/invitations/invitations.controller.ts
 **/